import React from 'react'
import _ from 'lodash'
import { use } from 'xadmin'
import { Loading, C } from 'xadmin-ui'
import { schemaConvert } from 'xadmin-form'
import { Form, Card, Popover } from 'antd'
import { _t } from 'xadmin-i18n'
import { EditOutlined } from '@ant-design/icons'

const Item = props => {
  const { item, value, field, schema, componentClass, wrap, editable, ...itemProps } = use('model.list.item', props)

  const RawWrapComponent = wrap || 'span'
  const WrapComponent = editable ? RawWrapComponent : ({ children, ...props }) => {
    const [edit, setEdit] = React.useState(false)
    return (
      <Popover content={(<C is="Model.ItemEditForm" item={item} field={field} value={value} schema={schema} onClose={() => setEdit(false)} />)}
        trigger="click" onVisibleChange={setEdit} visible={edit} placement="right" >
        <RawWrapComponent {...props} style={{ cursor: 'pointer' }}>{children} <EditOutlined /></RawWrapComponent>
      </Popover>
    )
  }

  if (item == undefined || item == null) {
    return <WrapComponent><span className="text-muted">{_t('Null')}</span></WrapComponent>
  }

  if (componentClass) {
    const ItemComponent = componentClass
    return <ItemComponent item={item} value={value} field={field} schema={schema} wrap={WrapComponent} {...itemProps} />
  } else {
    return <WrapComponent>{value == undefined || value == null ? <span className="text-muted">{_t('Null')}</span> : value}</WrapComponent>
  }

}

const FieldGroup = ({ label, field, children }) => {
  const attrs = field.attrs || {}
  const extra = field.description || field.help
  const size = (field.option && field.option.groupSize) || attrs.groupSize || {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 }
    }
  }

  const groupProps = { extra, ...size, required: field.required }
  return (
    <Form.Item label={label} {...groupProps}>
      {children}
    </Form.Item>
  )
}

const ModelInfo = ({ data, title, schema, model, loading, saveItem, ...formProps }) => {

  const renderFields = () => {
    return schemaConvert(model).fields.map(field => {
      field.option = { ...field.option, ...formProps }
      return (
        <FieldGroup key={field.key} label={field.label} field={field}>
          <Item item={data} field={field.key} value={data[field.key]} inList={false} selected={false} wrap={
            ({ children }) => children
          } />
        </FieldGroup>)
    })
  }

  return loading ? <Loading /> : (<Form>{renderFields()} </Form>)
}

export default (props) => <ModelInfo {...use('model.get', props)} />
